import Config from '@skin_config';
import { getTerminalLanguage } from '../languageByIdOrConfig';

export function HandleLotteryGame(user, gameId, forSecondScreen, limitgroupId, tableId, openType) {
  let gameUrl;
  const { urlPrefix } = Config.casino;
  const userInfo = user;
  const url = window.location.search;
  let gameMode = 'real';
  const urlParams = new URLSearchParams(url);
  const gameslug = urlParams.get('tableid') || tableId;
  const isDualscreen = sessionStorage.getItem('dualscreen') === 'true';
  const authData = JSON.parse(sessionStorage.getItem('authData'));
  const cashdaskStatus = userInfo.loggedInByRFID || userInfo.loggedIn ? 'false' : 'true';
  let casinoToken = (userInfo.loggedInByRFID || userInfo.loggedIn) ? userInfo.authData.auth_token : authData.token; // todo get 2chars language code
  const terminalLang = getTerminalLanguage();
  const lang = Config.swarm.languageMap[terminalLang] || terminalLang;
  casinoToken = encodeURIComponent(casinoToken);
  gameUrl = `${urlPrefix}/${Config.casino.terminalLauncherPrefix}?gameid=${gameId}&language=${lang}&partnerid=${authData.pid}&terminalid=${authData.tid}${gameslug ? (`&tableid=${gameslug}`) : ''}&iscashdesk=${cashdaskStatus}&devicetypeid=6&platformType=2&token=${casinoToken}${openType ? `&openType=${openType}` : ''}`;
  if (isDualscreen) {
    if (forSecondScreen) {
      gameUrl += '&screenIndex=2';
      gameMode = 'fun';
    } else {
      gameUrl += '&screenIndex=1';
    }
  }
  if (limitgroupId) {
    gameUrl += `&limitgroupId=${limitgroupId}`;
  }
  gameUrl += `&openType=${gameMode}`;
  if (!isDualscreen && forSecondScreen) { // in case one screen terminal asks for second screen video, return empty;
    gameUrl = null;
  }
  return gameUrl;
}

//
//
// https://games.efbetshop.com/LaunchGame?partnerId=18762167&gameId=500009124&language=en&openType=fun&devicetypeid=1&fronttypeid=1&exitURL=https%3A%2F%2Fefbetshop.com&deposit_url=https%3A%2F%2Fefbetshop.com%3Fprofile%3Dopen%26account%3Dbalance%26page%3Ddeposit&BPUrl=https%3A%2F%2Fefbetshop.com%3Fprofile%3Dopen%26selectedRewardPage%3DadditionalRewards%26account%3Drewards%26page%3Drewards&frameId=gameView&logoSource=%2Flogo.svg%3Fv%3D1734002599

export function HandleLotteryGameWeb(gameId) {
  const { urlPrefix } = Config.casino;
  const authData = JSON.parse(sessionStorage.getItem('authData'));
  const terminalLang = getTerminalLanguage();
  const lang = Config.swarm.languageMap[terminalLang] || terminalLang;
  return `${urlPrefix}/${Config.casino.webLauncherPrefix}?partnerId=${authData.pid}&gameId=${gameId}&language=${lang}&openType=fun&devicetypeid=1&fronttypeid=1`;
}

/**
 * @name getCasinoGameBaseUrl
 * @description returns game url
 * @param externalGameId
 * @param playType
 * @param authToken
 * @returns {string}
 */
